// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__bOknW","header":"Messages_header__2npNc"};